export const NAME = 'productHistory';

export const HISTORY_CATEGORY_LIST = [
  {'id': 0, 'name': '無分類'},
  {'id': 1, 'name': '生鮮食材'},
  {'id': 2, 'name': '醬料'},
  {'id': 3, 'name': '包材'},
  {'id': 4, 'name': '產品責任險'}
]